<template>
  <div class="modal-container">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">业务员</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <vxe-input v-model="listQuery.userName" placeholder="业务员" type="search" style="float: right;" @search-click="search" @keyup.enter.native="search" clearable></vxe-input>
      <!-- <div class="search-box">
        <vxe-input
          v-model="filterName"
          type="search"
          placeholder="请输入订单号"
          @keyup.enter.native="search"
          @search-click="search"
          style="width:200px;margin-right:10px"
        ></vxe-input>
        <vxe-input
          v-model="orderName"
          type="search"
          :placeholder="orderType === 1 ? '请输入托运人名称' : ( orderType === 2 ? '请输入承运人名称' : '请输入实际承运人名称')"
          @keyup.enter.native="search"
          @search-click="search"
          style="width:200px"
        ></vxe-input>
      </div>-->
    </div>
    <div>
      <vxe-table
        ref="xTable1"
        class="table-style"
        height="400"
        border="none"
        align="center"
         :auto-resize="true"
        :data="tableData"
        :radio-config="{highlight: true}"
        highlight-hover-row
        @cell-click="cellClickEvent"
      >
        <vxe-table-column field="id" title="序号" show-overflow width="60"></vxe-table-column>
        <vxe-table-column field="name" title="业务员姓名" show-overflow ></vxe-table-column>
      </vxe-table>
    </div>
    <vxe-pager
      background
      size="small"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="totalResult"
      @page-change="changePage1"
    ></vxe-pager>
  </div>
</template>

<script>
import $api from "@/apiProvider";
export default {
  name: "ChooseSalesMan",
  data() {
    return {
      tableData3: [],
      filterName: null,
      orderName: null,
      tableData: [],
      selectRow: null,
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
      selectTab: "tab1",
      listQuery: {
        page: 1,
        rows: 10,
        orderBy: 2,
        isDesc:1,
        userName:null
      },
    };
  },
  //获取列表
  methods: {
    init() {
      (this.currentPage = 1),
        (this.listQuery = {
          page: 1,
          rows: 10,
        }),
        this.getList();
    },
    search(){
      this.currentPage = 1
      this.listQuery.page = 1;
      this.getList();
    },
    cancel() {},
    // search() {
    //   (this.currentPage = 1),
    //     (this.listQuery = {
    //       page: 1,
    //       rows: 10,
    //     }),
    //     this.getList();
    // },
    async getList() {
      this.loading = true;
      // let data = this.listQuery;
     let res = await $api.user.request("querySaleManagerList", this.listQuery);
      if (res.status == 1) {
        this.tableData = res.data.rows;
        this.totalResult = res.data.total;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    changePage1(val) {
      this.listQuery.page = val.currentPage;
      this.getList();
      console.log(`当前页: ${val}`);
    },
    clickEvent3(id) {
      this.$refs[id].togglePanel();
    },
    cellClickEvent({ row }) {
      this.selectRow = row;
      console.log(this.selectRow);
       this.$XModal.confirm("该操作将关联"+row.name+"业务员,是否确定？").then((type) => {
        if (type === "confirm") {
          this.$emit("chooseSalesMan", this.selectRow);
        }
      });
      
      //   console.log("单元格点击事件");
    },
  },
};
</script>

<style scoped>
.modal-container {
  position: relative;
  height: 100%;
}
.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.my-search {
  padding: 10px;
}

.my-search .vxe-input {
  height: 34px;
  width: 300px;
}
.my-search .vxe-input >>> .vxe-input--suffix {
  display: block !important;
  width: 60px;
  height: 32px;
  top: 1px;
  text-align: center;
  border-left: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  cursor: pointer;
}
.my-search .vxe-input >>> .vxe-input--inner {
  padding-right: 72px;
  border: 1px solid #dcdfe6;
}
</style>